import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    standalone: false
})
export class EmptyStateComponent implements OnInit {
  @Input() addPaddingBottom: boolean = true;
  @Input() titleKey: string | undefined;
  @Input() contentKeys: string[] = [];
  @Input() contentKeysSecondary: string[] = [];
  @Input() contentKeysSecondaryParams: Record<string, any> = {};
  @Input() backgroundColor: string = 'var(--teal-50)';
  @Input() imgSrc: string | undefined;
  @Input() buttonText: string | undefined;
  @Input() hasPadding: boolean = true;
  @Input() hasBoxShadow: boolean = true;
  @Input() paddingBottom: string = '';
  @Output() onButtonClick = new EventEmitter<void>();

  formattedMessage: string | undefined;

  constructor(private translocoService: TranslocoService) {
  }

  ngOnInit(): void {
    this.translocoService.selectTranslate('emptyState.stopwatch.message').subscribe((res: string) => {
      this.formattedMessage = this.boldLastWord(res);
    });
  }

  private boldLastWord(sentence: string): string {
    let words = sentence.split(' ');
    const lastWord = words[words.length - 1];
    const lastChar = lastWord.slice(-1);
    const hasPunctuation = [".", ",", ";", "!", "?"].includes(lastChar);

    if (hasPunctuation) {
      words[words.length - 1] = `<strong>${lastWord.slice(0, -1)}</strong>${lastChar}`;
    } else {
      words[words.length - 1] = `<strong>${lastWord}</strong>`;
    }

    return words.join(' ');
  }
}
